<template lang="pug">
  .bundle-details
    .col-sm-6.p0(v-if="firstCodeBundle.length > 1")
      label First Code Bundle
      GenericTable()
        tr(slot="thead")
          th Index
          th Code
          th Type
        tr(v-for="fcb in firstCodeBundle")
          td {{ fcb.codeIndex }}
          td {{ fcb.code }}
          td {{ fcb.codeType }}
    .col-sm-6.p0(v-if="lastCodeBundle.length > 1")
      label Last Code Bundle
      GenericTable()
        tr(slot="thead")
          th Index
          th Code
          th Type
        tr(v-for="lcb in lastCodeBundle")
          td {{ lcb.codeIndex }}
          td {{ lcb.code }}
          td {{ lcb.codeType }}
</template>

<script>
import GenericTable from '@/components/common/GenericTable'

export default {
  props: {
    firstCodeBundle: {
      required: true
    },
    lastCodeBundle: {
      required: true
    }
  },
  components: {
    GenericTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/BundleDetails.vue